import { currencyInCentsFormatter } from '@/utils/currencies';

/** "8h 45m", "2d 3h", "45m"; "0m" once the time has passed. */
export const formatTimeLeft = (until: Date, now: Date): string => {
  const totalMinutes = Math.max(0, Math.floor((until.getTime() - now.getTime()) / 60000));
  const days = Math.floor(totalMinutes / (24 * 60));
  const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
  const minutes = totalMinutes % 60;

  if (days > 0) return `${days}d ${hours}h`;
  if (hours > 0) return `${hours}h ${minutes}m`;
  return `${minutes}m`;
};

/** "Oct 27" in the member's time zone. */
export const formatShortDate = (date: Date, timeZone?: string | null): string =>
  date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    timeZone: timeZone || undefined
  });

/**
 * The last moment a mission still counts. expired_at is the next period's
 * midnight, so the member-facing range ends the moment before it.
 */
export const missionLastDay = (expiredAt: string): Date =>
  new Date(new Date(expiredAt).getTime() - 1);

/**
 * The reward as the app shows it: dollars, or points for members paid in EXP
 * ("25 points"). USD wins when both are set; null when there's no reward.
 */
export const formatMissionReward = (payoutTotals: Record<string, number>): string | null => {
  const usdCents = payoutTotals.usd_in_cents ?? 0;
  if (usdCents > 0) return currencyInCentsFormatter(usdCents);

  const expCents = payoutTotals.exp_in_cents ?? 0;
  if (expCents > 0) {
    const points = expCents / 100;
    return `${points.toLocaleString('en-US', { maximumFractionDigits: 2 })} points`;
  }
  return null;
};
